import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetVoucherByCorporateClientParams, GetVoucherByCorporateClientResponse } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const getVoucherByCorporateClient = createAsyncThunk<
  GetVoucherByCorporateClientResponse,
  GetVoucherByCorporateClientParams
>(
  'vouchers/getVoucherByCorporateClient',
  async (params, { rejectWithValue }) => {
    try {
      const data = await VouchersAPI.getVoucherByCorporateClient(params);
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while getting voucher by corporate client", error?.response?.data);
        return rejectWithValue(error?.response?.data || "Unknown error");
      }
      else {
        console.error("Error while getting voucher by corporate client", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  })
